export default __webpack_public_path__ + "static/media/4.75d69730.jpg";